export default __webpack_public_path__ + "static/media/pink_macaroon.0d61abd0.png";